import apiBase from "../../api/axios";

export const getActividadesAplicacionService = async (
  page = 1,
  search = "",
  talento = "",
) => {
  let url = `v1/talentos-global/actividades-aplicacion/?page=${page}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (talento) url += `&talento=${talento}`;
  const response = await apiBase.get(url);
  return response.data;
};

export const getActividadesAplicacionSelectoresService = async (
  search = "",
) => {
  let url = `v1/talentos-global/selectores/actividades-aplicacion/`;
  if (search) url += `?search=${encodeURIComponent(search)}`;
  const response = await apiBase.get(url);
  return response.data;
};

export const getActividadAplicacionByIdService = async (id) => {
  const response = await apiBase.get(
    `v1/talentos-global/actividades-aplicacion/${id}/`,
  );
  return response.data;
};

export const updateActividadAplicacionService = async (id, payload) => {
  const response = await apiBase.put(
    `v1/talentos-global/actividades-aplicacion/${id}/`,
    payload,
  );
  return response.data;
};

export const toggleActividadAplicacionActiveService = async (id) => {
  const response = await apiBase.post(
    `v1/talentos-global/actividades-aplicacion/${id}/toggle_active/`,
  );
  return response.data;
};

export const createMultiplesActividadesAplicacionService = async (payload) => {
  const response = await apiBase.post(
    `v1/talentos-global/actividades-aplicacion/crear-multiples/`,
    payload,
  );
  return response.data;
};
